import { render, staticRenderFns } from "./alertMessageTable.vue?vue&type=template&id=965bc6a8&scoped=true&"
import script from "./alertMessageTable.vue?vue&type=script&lang=js&"
export * from "./alertMessageTable.vue?vue&type=script&lang=js&"
import style0 from "./alertMessageTable.vue?vue&type=style&index=0&id=965bc6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965bc6a8",
  null
  
)

export default component.exports